import { IconPen, IconPlusRounded, IconTrash } from "@aksara-ui/icons";
import {
  Anchor,
  Badge,
  Box,
  Button,
  Card,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import React, { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { BannerConfirmationModal, BannerFormModal } from "./components";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBanners,
  setModalConfirmationOpen,
  setModalFormOpen,
} from "redux/actions";
import { LazyLoadImage } from "react-lazy-load-image-component";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const BannersContent: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const dispatch = useDispatch();

  const { appUrl, isLoading, isModalFormOpen, isModalConfirmationOpen } =
    useSelector((state: any) => state.globalReducer);
  const { banners } = useSelector((state: any) => state.bannerReducer);

  const [selectedBannerId, setSelectedBannerId] = useState("");

  const handleOpenFormModal = (bannerId: string = "") => {
    dispatch(setModalFormOpen(true) as any);
    setSelectedBannerId(bannerId);
  };

  const handleCloseFormModal = () => {
    dispatch(setModalFormOpen(false) as any);
    setSelectedBannerId("");
  };

  const handleOpenConfirmModal = (bannerId: string) => {
    dispatch(setModalConfirmationOpen(true) as any);
    setSelectedBannerId(bannerId);
  };

  const handleCloseConfirmModal = () => {
    dispatch(setModalConfirmationOpen(false) as any);
    setSelectedBannerId("");
  };

  useEffect(() => {
    // if (!banners.length) {
    dispatch(getAllBanners() as any);
    // }
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "left" : "center"}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Banner Management
          </Text>
        </Box>

        <Box display={"flex"}>
          <Stack display={"flex"} flexDirection={"row"} style={{ gap: 10 }}>
            <Button
              variant={"primary"}
              borderRadius={10}
              style={{ fontWeight: 600 }}
              icon={IconPlusRounded}
              iconPosition={"left"}
              size={32}
              onClick={() => handleOpenFormModal()}
            >
              Add Banner
            </Button>
          </Stack>
        </Box>
      </HeaderWrapper>

      <Card overflow={"auto"} elevation={2} maxHeight={"100%"}>
        <Table>
          <TableHead position={"sticky"} top={0} backgroundColor={"white"}>
            <TableHeadRow>
              <TableHeadCell>Desktop Banner Image</TableHeadCell>
              <TableHeadCell>Mobile Banner Image</TableHeadCell>
              <TableHeadCell>Location</TableHeadCell>
              <TableHeadCell>Redirect Url</TableHeadCell>
              <TableHeadCell>Sort Order</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={6} />
            ) : !banners.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={6} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              banners.map((banner: any) => {
                return (
                  <TableBodyRow key={banner.id}>
                    <TableBodyCell>
                      {banner.desktop_img_url ? (
                        <LazyLoadImage
                          key={banner.id}
                          src={`${appUrl}/storage/${banner.desktop_img_url}`}
                          alt="desktop-banner-image "
                          width={200}
                          height={"100%"}
                          effect="blur"
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell>
                      {banner.mobile_img_url ? (
                        <LazyLoadImage
                          key={banner.id}
                          src={`${appUrl}/storage/${banner.mobile_img_url}`}
                          alt="mobile-banner-image"
                          width={200}
                          height={"100%"}
                          effect="blur"
                        />
                      ) : (
                        ""
                      )}
                    </TableBodyCell>
                    <TableBodyCell>{banner.location}</TableBodyCell>
                    <TableBodyCell>
                      <Anchor
                        color={theme.colors.blue07}
                        target={"_blank"}
                        href={banner.redirect_url}
                        fontWeight={500}
                        scale={[200, 300]}
                      >
                        {banner.redirect_url}
                      </Anchor>
                    </TableBodyCell>
                    <TableBodyCell>
                      <Badge
                        size={"md"}
                        variant={"info"}
                        style={{
                          paddingLeft: 20,
                          paddingRight: 20,
                        }}
                      >
                        {banner.sort_order}
                      </Badge>
                    </TableBodyCell>
                    <TableBodyCell>
                      <IconButton
                        onClick={() => handleOpenFormModal(banner.id)}
                      >
                        <IconPen fill={theme.colors.green06} />
                      </IconButton>
                      <IconButton
                        onClick={() => handleOpenConfirmModal(banner.id)}
                      >
                        <IconTrash fill={theme.colors.red06} />
                      </IconButton>
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>

      <BannerFormModal
        bannerId={selectedBannerId}
        isOpen={isModalFormOpen}
        onClose={() => handleCloseFormModal()}
      />

      <BannerConfirmationModal
        bannerId={selectedBannerId}
        isOpen={isModalConfirmationOpen}
        onClose={() => handleCloseConfirmModal()}
      />
    </Box>
  );
};

export default BannersContent;
